// Slug a node title into a download filename ("Top recognizers" → "top-recognizers"),
// falling back to a node-type default when there's no usable title. Shared by the
// chart (PNG/CSV) and table (CSV) export action bars.
export function exportFilename(title: string | undefined, fallback: string): string {
	const slug = (title ?? '')
		.toLowerCase()
		.replace(/[^a-z0-9]+/g, '-')
		.replace(/^-+|-+$/g, '');
	return slug || fallback;
}
